<div nxLayout="grid" class="container">
  <div
    nxRow
    class="std-pd-top-m std-pd-bottom-m std-pd-left-3m std-pd-right-3m"
  >
    <div nxCol="6" class="">
      <div class="std-ta-left">
        <a routerLink="/login">
          <img src="assets/images/shared/logo.svg" />
        </a>
      </div>
    </div>
    <div class="allianz-link" nxCol="6">
      <div class="std-ta-right">
        <nx-link>
          <a
            class="allianz-link-font"
            href="https://www.allianz.com.my"
            target="_blank"
          >
            {{ "HEADER.ALLIANZ_MALAYSIA" | translate }}
          </a>
        </nx-link>
      </div>
    </div>
  </div>
</div>
